import React from 'react';
import Styles from './styles.module.css';
import { IoIosTimer } from "react-icons/io";
import { MdCurrencyYen } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
import { LiaStoreSolid } from "react-icons/lia";
import { IoIosWoman } from "react-icons/io";
import { FaPeopleGroup } from "react-icons/fa6";
import { RiScissors2Fill } from "react-icons/ri";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { FaPeopleCarryBox } from "react-icons/fa6";
import { GiBeard } from "react-icons/gi";
import { IoRepeatOutline } from "react-icons/io5";
import { LuCrown } from "react-icons/lu";
import { FaMountainSun } from "react-icons/fa6";
import { numberData } from 'src/type';

type RecruitPageNumberProps = {
  number: numberData;
  // 求人編集のプレビュー時のみ true。未設定の枠に例（灰色）を出す。
  preview?: boolean;
};

const NUMBER_PLACEHOLDERS = [
  { tag: "例）創業年度", value: "例）15年" },
  { tag: "例）平均勤続年数", value: "例）8年" },
  { tag: "例）店舗数", value: "例）5店舗" },
  { tag: "例）採用人数", value: "例）3人" },
];

// 項目名 → (アイコン, 値, 単位)。学生アプリの RecruitNumber._stat と同じ並び・単位
const stat = (n: numberData, tag: string): [React.ReactNode, string, string] => {
  switch (tag) {
    case '創業から': return [<IoIosTimer />, n.text1, '年'];
    case '平均勤続年数': return [<SlCalender />, n.text2, '年'];
    case '店舗数': return [<LiaStoreSolid />, n.text3, '店'];
    case '男女比': return [<IoIosWoman />, n.text4, ''];
    case '採用人数': return [<FaPeopleGroup />, n.text5, '人'];
    case '最短デビュー': return [<RiScissors2Fill />, n.text6, 'ヶ月'];
    case '平均顧客単価': return [<FaRegMoneyBillAlt />, n.text7, '千円'];
    case 'アシスタント給与': return [<MdCurrencyYen />, n.text8, '万'];
    case '引越し金': return [<FaPeopleCarryBox />, n.text9, '万'];
    case '平均年齢': return [<GiBeard />, n.text10, '歳'];
    case 'リピート率': return [<IoRepeatOutline />, n.text11, '％'];
    case 'コンテスト受賞数': return [<LuCrown />, n.text12, '回'];
    case '地方出身者割合': return [<FaMountainSun />, n.text13, '％'];
    default: return [null, '', ''];
  }
};

// 数字で見る。4項目を2×2のタイルにして、数字を大きく見せる(学生アプリと同じ)
const RecruitPageNumber: React.FC<RecruitPageNumberProps> = React.memo(({ number, preview }) => {

  return (
    <>
    <div className={Styles.score}>
      {[0, 1, 2, 3].map((i) => {
        const tag = number.tags[i];
        const ph = !tag && preview;
        const [icon, value, unit] = stat(number, tag);
        const empty = !String(value ?? '').trim();
        return (
          <div key={i} className={Styles.tile}>
            <div className={Styles.tile_head}>
              {icon && <span className={Styles.number_icon}>{icon}</span>}
              <h3 className={ph ? Styles.number_ph : undefined}>{tag || (preview ? NUMBER_PLACEHOLDERS[i].tag : "")}</h3>
            </div>
            <h4 className={ph ? Styles.number_ph : undefined}>
              {ph ? NUMBER_PLACEHOLDERS[i].value : (
                <>
                  {empty ? '-' : value}
                  {!empty && unit && <span className={Styles.unit}> {unit}</span>}
                </>
              )}
            </h4>
          </div>
        );
      })}
    </div>
    </>
  );
});

export default RecruitPageNumber;
